export function LocationBlockedIcon(props: {
  height?: number
  className?: string
}) {
  const { className } = props

  const height = props.height ? props.height * 4 : 48
  const width = height * 1.25

  return (
    <svg
      className={className}
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m539.62 60c-185.12 0-335.62 150.72-335.62 336 0 45.098 11.68 94.875 26.25 132.75 92.375 196.5 184.79 393.54 277.12 590.25 5.7578 12.332 19.016 21 32.625 21s26.867-8.668 32.625-21c33.105-70.199 66.082-140.43 99-210.75 33.793 24.84 75.441 39.75 120.38 39.75 112.24 0 204-91.762 204-204 0-95.113-66.09-175.3-154.5-197.62 2.7852-5.8594 5.4805-11.77 8.25-17.625 14.684-37.969 26.25-87.68 26.25-132.75 0-185.39-151.25-336-336.38-336zm0 72c146.28 0 264.38 117.57 264.38 264 0 31.168-10.512 77.809-21.75 106.88l-18.375 39.375c-98.938 13.895-175.88 99.125-175.88 201.75 0 39.27 11.336 76.047 30.75 107.25l-78.75 168-242.25-516.38c-11.207-29.137-21.75-75.773-21.75-106.88 0-146.54 117.35-264 263.62-264zm0.37109 84c-98.957 0-180 80.992-180 180s81.043 180 180 180c98.957 0 180-80.883 180-180s-81.043-180-180-180zm0 72c60.113 0 108 47.848 108 108 0 60.156-47.887 108-108 108-60.113 0-108-47.734-108-108 0-60.262 47.887-108 108-108zm252 324c23.512 0 45.453 5.8867 64.5 16.5l-180 179.62c-10.52-18.984-16.5-40.727-16.5-64.125 0-73.328 58.672-132 132-132zm115.5 67.5c10.613 19.047 16.5 40.988 16.5 64.5 0 73.328-58.672 132-132 132-23.582 0-45.414-6.2031-64.5-16.875z" />
    </svg>
  )
}
